export const name = '@lifi/widget';
export const version = '3.34.1';
//# sourceMappingURL=version.js.map